$.fn.actionToolbarConfirm = function(options) {
  options = $.extend({
    messageHtml: "Are you sure?",
    yesHtml: '<svg class="cyclops-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use></svg> yes',
    noHtml: '<svg class="cyclops-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-times"></use></svg> no',
    timeout: 3000,
    easing: libraries.jqueryUi ? 'easeInOutQuad' : 'swing',
    classes: "action-toolbar-confirm-primary"
  }, options);
  return $(this).each(function(idx, action) {
    var $action, $actions, $area, $confirm, $noBtn, $yesBtn, events, reset, show, timeoutTracker;
    $action = $(action);
    $confirm = $("<div class='action-toolbar-confirm " + options.classes + "'> <div class='buttons'> <button class='yes'>" + options.yesHtml + "</button><button class='no'>" + options.noHtml + "</button> </div> <div class='message'>" + options.messageHtml + "</div> </div>");
    $confirm.hide();
    $yesBtn = $confirm.find('.yes');
    $noBtn = $confirm.find('.no');
    $area = $action.parents('.action-area');
    $actions = $area.find('.action-toolbar, .action-toolbar-left, .action-toolbar-right');
    timeoutTracker = null;
    $area.append($confirm);
    reset = function(event) {
      if (event) {
        event.preventDefault();
      }
      $actions.animate({
        'margin-top': 0
      }, {
        duration: 200,
        easing: options.easing,
        complete: function() {
          $area.removeClass("action-toolbar-confirm-shown");
          return $confirm.hide();
        }
      });
    };
    show = function(event) {
      if (event) {
        event.preventDefault();
      }
      if ($action.is(':disabled')) {
        return;
      }
      $confirm.show();
      $area.addClass("action-toolbar-confirm-shown");
      $actions.animate({
        'margin-top': -40
      }, {
        duration: 200,
        easing: options.easing
      });
    };
    $confirm.hover(function() {
      if (timeoutTracker) {
        return window.clearTimeout(timeoutTracker);
      }
    }, function() {
      return timeoutTracker = window.setTimeout(reset, options.timeout);
    });
    events = $._data($action[0], "events");
    if (events) {
      events.click.forEach(function(c) {
        $yesBtn.on("click", c.handler);
      });
    }
    $yesBtn.on("click", reset);
    $noBtn.on("click", reset);
    $action.off("click");
    return $action.on("click", show);
  });
};
